import { render } from "./PhoneNumberSelect.vue?vue&type=template&id=50e96e8b"
import script from "./PhoneNumberSelect.vue?vue&type=script&lang=js"
export * from "./PhoneNumberSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__